import React from 'react';
import styled from 'styled-components';

type YoutubeEmbedProps = {
  id: string;
  width?: number;
  height?: number;
};

const YoutubeEmbed: React.FC<YoutubeEmbedProps> = ({ id, width = 800, height = 450 }) => {
  const dimensionPadding = (height / width) * 100;

  const embedCode = `<iframe loading="lazy" width="${width}" height="${height}" src="//www.youtube-nocookie.com/embed/${
    id.split('&')[0]
  }?autoplay=0&rel=0&modestbranding=1" frameborder="0" allowfullscreen></iframe>`;

  return <EmbedStyled padding={dimensionPadding} dangerouslySetInnerHTML={{ __html: embedCode }} />;
};

type EmbedStyleProps = {
  padding: number;
};

const EmbedStyled = styled.div<EmbedStyleProps>`
  width: 100%;
  position: relative;
  padding-bottom: ${(props) => props.padding}%;
  height: 0;
  overflow: hidden;
  margin: 1.5rem 0;

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export default YoutubeEmbed;
